import { Certificate } from 'app/library/certificate/models/certificate.model';
import { Module } from 'app/library/module/models/module.model';
import { newModule } from 'app/library/module/models/newModule';
import { SectionType } from 'app/library/section/enums/section-type.enum';
import { ISectionQuery } from 'app/library/section/interfaces/section.query.interface';
import { ELearningSection } from 'app/library/section/models/eLearning-section.model';
import { FeedbackSection } from 'app/library/section/models/feedback-section.model';
import { FilesSection } from 'app/library/section/models/files-section.model';
import { IntegratedQuizSection } from 'app/library/section/models/integrated-quiz-section.model';
import { OneFileSection } from 'app/library/section/models/one-file-section.model';
import { QuizSection } from 'app/library/section/models/quiz-section.model';
import { RecommendationsSection } from 'app/library/section/models/recommendations-section.model';
import { Section } from 'app/library/section/models/section.model';
import { SurveySection } from 'app/library/section/models/survey-section.model';
import { TextSection } from 'app/library/section/models/text-section.model';
import { VideoSection } from 'app/library/section/models/video-section.model';
import { IModuleCertificateQuery } from '../interfaces/module-certificate.query.interface';
import { ModuleCertificate } from './module-certificate.model';

export class ModuleCertificateExtended extends ModuleCertificate {
    module: Module;
    certificate: Certificate;
    section?: Section;
    isSelected?: boolean;

    private _newSection(query: ISectionQuery): Section {
        switch (query.type) {
            case SectionType.Files:
                return new FilesSection(query);
            case SectionType.Text:
                return new TextSection(query);
            case SectionType.Feedback:
                return new FeedbackSection(query);
            case SectionType.Quiz:
                return new QuizSection(query);
            case SectionType.IntegratedQuiz:
                return new IntegratedQuizSection(query);
            case SectionType.ELearning:
                return new ELearningSection(query);
            case SectionType.Survey:
                return new SurveySection(query);
            case SectionType.OneFile:
                return new OneFileSection(query);
            case SectionType.Video:
                return new VideoSection(query);
            case SectionType.Recommendations:
                return new RecommendationsSection(query);
        }
    }

    constructor(moduleCertificate?: IModuleCertificateQuery) {
        super(moduleCertificate);

        if (moduleCertificate) {
            this.module = newModule(moduleCertificate.module);
            this.certificate = new Certificate(moduleCertificate.template);
            if (moduleCertificate.section) {
                this.section = this._newSection(moduleCertificate.section);
            } else {
                this.section = null;
            }
        } else {
            this.module = null;
            this.certificate = null;
            this.section = null;
        }
    }
}
